import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass/styled-components';
import moment from 'moment';
import { Message, PanelRow, Tooltip } from '@getro/rombo';

import getOcpStatus from '../../../helpers/getOcpStatus';

const JobSource = ({ source }) => {
  const { activeJobsCount, scrapedAt, scraperStatus, publicUrl, url, updateFrequency } = source;
  const ocpStatus = getOcpStatus(scraperStatus);

  return (
    <Flex width={1} flexDirection="column" mb={4} sx={{ backgroundColor: 'blue.50', borderRadius: 10, padding: 30 }}>
      <PanelRow title="URL" mb={3}>
        <Text sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '100%' }}>
          {publicUrl || url}
        </Text>
      </PanelRow>
      <PanelRow title="Update frequency" mb={3}>
        <Text>
          {scraperStatus === 'manual' ? 'Monthly' : `${updateFrequency || 0} ${updateFrequency > 1 ? 'days' : 'day'}`}
        </Text>
      </PanelRow>
      {ocpStatus.explanationText && (
        <PanelRow mt={[3, 3, 0]} mb={3}>
          <Message type="info">
            <span dangerouslySetInnerHTML={{ __html: ocpStatus.explanationText }} />
          </Message>
        </PanelRow>
      )}
      <PanelRow title="Last updated" mb={3}>
        {scrapedAt ? (
          <Tooltip
            content={scrapedAt ? moment(scrapedAt).format('D MMM, YYYY [at] hh:mm a') : 'Not available'}
            trigger={<span>{moment().from(scrapedAt, true)} ago</span>}
          />
        ) : (
          'Never'
        )}
      </PanelRow>
      <PanelRow title="Jobs">
        <Text>{activeJobsCount || 0} Total</Text>
      </PanelRow>
    </Flex>
  );
};

JobSource.propTypes = {
  source: PropTypes.shape({
    activeJobsCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    scrapedAt: PropTypes.string,
    scraperStatus: PropTypes.string,
    url: PropTypes.string,
    publicUrl: PropTypes.string,
    updateFrequency: PropTypes.number,
  }).isRequired,
};

export default JobSource;
